import { Importance } from '@blisspointmedia/bpm-types/dist/Creative';

// Rescales the unsuppressed importances to percentages of their own total, to one decimal.
export const toImportanceShares = (
  attributeImportanceData: Importance[],
  suppressedAttributes: Set<string>
): Importance[] => {
  const visible = attributeImportanceData.filter(
    attribute => !suppressedAttributes.has(attribute.name)
  );
  const total = visible.reduce((sum, attribute) => sum + attribute.val, 0);
  return visible.map(({ name, val }) => ({
    name,
    val: total ? Math.round((val / total) * 100 * 10) / 10 : 0
  }));
};
